import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__style_list_bullets",
  "use": "compose__style_list_bullets-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol viewBox=\"0 0 16 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"compose__style_list_bullets\">\n  <title>Add bulleted list</title>\n  <path stroke-linecap=\"round\" d=\"M3.762 11.647h11.285M3.762 6.794h11.285M3.282 1.941h11.765\" />\n  <circle cx=\".47\" cy=\"1.844\" r=\"1\" />\n  <path stroke-linecap=\"round\" d=\"M1.017 6.794h-.47M1.017 11.647h-.47\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol